import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { hideTooltip } from "../lib/dynamicTooltip";
import { authSelector } from "../components/Auth/AuthSlice";
import NoAccessPage from "../components/Routers/NoAccessPage";
import SuspenseLoader from "../components/Routers/SuspenseLoader";
import {
  findFirstAllowedAbacRoute,
  hasNoAllowedAbacPages,
} from "../components/User/Abac/abacRouteMap";
import { shouldEnforceAbacForUser } from "../components/User/Abac/abacAccess";
import { useAbacSessionPending } from "../hooks/useAbacAccess";
import { useFullscreen } from "../contexts/FullscreenContext";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";

const MainLayout = () => {
  const location = useLocation();
  const { user, abacPermissions } = useSelector(authSelector);
  const { isFullscreen = false } = useFullscreen();
  const profileData = globalThis.profileData || {};
  const abacPending = useAbacSessionPending();
  const enforceAbac = shouldEnforceAbacForUser(user, profileData);
  const hideAppChrome = hasNoAllowedAbacPages(
    abacPermissions,
    user,
    profileData
  );
  const noLanding =
    enforceAbac &&
    abacPermissions != null &&
    findFirstAllowedAbacRoute(abacPermissions, user, profileData) == null;
  const isApiRunnerPage =
    location.pathname.includes("/api-runner") ||
    location.pathname.startsWith("/developer/sdk");

  useEffect(() => {
    hideTooltip();
  }, [location.pathname, location.search]);

  // MA permissions still loading — neutral wait (not No Access UI).
  if (abacPending && enforceAbac) {
    return (
      <SuspenseLoader>
        <></>
      </SuspenseLoader>
    );
  }

  // All toggles off / no landing → full-page No Access (no empty sidebar shell).
  if (enforceAbac && (hideAppChrome || noLanding)) {
    return <NoAccessPage />;
  }

  return (
    <div
      className={`d-flex layoutContainer${isFullscreen ? " fullscreen-mode" : ""}`}
    >
      {!isFullscreen && <Sidebar />}
      <div className="flex-grow-1 main">
        {!isFullscreen && <Navbar />}
        {isApiRunnerPage ? (
          <div className="contents position-relative api-runner-contents">
            <Outlet />
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default MainLayout;
